import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormGroupDirective, Validators, FormBuilder } from '@angular/forms';
import { debounceTime } from 'rxjs/operators';
import { EnumService } from 'src/app/utility/services/enum-service/enum.service';
import { MessageService } from 'src/app/utility/services/message/message.service';
import { GroupGlSubmissionService } from '../../service/group-gl-submission/group-gl-submission.service';

@Component({
  selector: 'app-online-generate-input-gl',
  templateUrl: './online-generate-input-gl.component.html',
  styleUrls: ['./online-generate-input-gl.component.scss']
})
export class OnlineGenerateInputGlComponent implements OnInit {

  formDirectiveInputGeneration: FormGroupDirective;
  relationList: any = [];
  groupPolicies: any = [];
  enrolls: any = [];
  filteredEnrolls: any = [];
  enrolProducts: any[] = [];
  dependentProducts: any = [];
  claimPayToList: any = [];
  insuredName: string;
  groupPolicyNo: string;
  groupPolicyName: string;
  certificateNo: string;
  birthYear: number;
  enrolId: number;
  selectedPatientId = 0;
  selectedProductId = 0;
  today = new Date();
  // Form Group
  inputGenerationForm = this.fb.group({
    groupPolicyId: [null],
    productId: [null, [Validators.required]],
    insuredName: [''],
    relationId: [null],
    enrolDependentId: [0],
    natureOfSickness: [null],
    enrolId: [null, [Validators.required]],
    enrol: [null, [Validators.required]],
    componentValidatorId: [null],
    claimAmount: [0],
    payTo: [null, [Validators.required]],
    authLetter: [false, [Validators.required]],
    dateOfIncident: ['', [Validators.required]],
    lastWorkedFullTimeDate: null,
    insuranceAmount: [0, [Validators.required, Validators.min(0)]],
    insuredAddress: ['', [Validators.maxLength(500)]],
  });

  @Output() onValidInput = new EventEmitter<any>();
  @Output() onProductChange = new EventEmitter<any>();

  constructor(
    private fb: FormBuilder,
    private enumService: EnumService,
    private groupGlSubmissionService: GroupGlSubmissionService,
    private messageService: MessageService,
  ) { }

  ngOnInit() {
    this.groupGlSubmissionService.getGroupPoliciesOfLoggedInHRUser().subscribe(res => {
      this.groupPolicies = res;
    }, err => this.messageService.show(err.error.message, 'error'));

    this.enumService.getClaimPayTo().subscribe(res => {
      this.claimPayToList = res;
    });
    this.setSubscriberEnrolFilter();
  }
  payTo(value) {
     value != 3 ?
      this.inputGenerationForm.patchValue({authLetter: true}):
      this.inputGenerationForm.patchValue({authLetter: false});
  }
  setSubscriberEnrolFilter() {
    this.inputGenerationForm.controls['enrol'].valueChanges
      .pipe(debounceTime(300))
      .subscribe(value => {
        this.filteredEnrolls = value && typeof (value) == 'string' ? this.enrolls.filter(x => x.certificateNumber.toLowerCase().includes(value.toLowerCase())) : this.enrolls;
      });
  }

  dependentChange(event: any) {
    // reset this value to prevent form submission if productId is not selected.
    this.inputGenerationForm.patchValue({
      productId: null
    });
  }

  groupPolicyChange = (event: any) => {
    //console.log('groupPolicyChange', event.value);
    this.groupGlSubmissionService.getEnrolsByGroupPolicyId(event.value).subscribe(res => {
      this.enrolls = res;
      this.filteredEnrolls = res;
    },
    err => this.messageService.show(err.error.message, 'error'));
  }



  displayFn = (enrol): string => {
    //console.log('Enrol', enrol);
    if (typeof (enrol) == 'object' && enrol) {

      // this.selectedProductId = 0;
      // this.selectedPatientId = 0;
      // this.resetFromSettings();

      this.inputGenerationForm.patchValue({
        enrolId: enrol.id,
        insuredName: `${enrol.firstname} ${enrol.lastname}`
      });

      //Get Claim Submission Data
      this.groupGlSubmissionService.getClaimSubmissionDataForGL(enrol.id).subscribe(res => {
        this.relationList = res.data.relations;
        this.enrolProducts = res.data.enrolproducts;
        this.dependentProducts = res.data.dependentProducts;
      },
      err => this.messageService.show(err.error.message, 'error'));

      return enrol.certificateNumber ? enrol.certificateNumber : '';
    }
    return '';
  }

  goToUploadDocument(formDirective1: FormGroupDirective) {
    this.formDirectiveInputGeneration = formDirective1;
    this.notifyParentComponent();
  }

  resetFromSettings() {
    if (this.formDirectiveInputGeneration != null) {
      this.formDirectiveInputGeneration.resetForm();
    }
    // this.inputGenerationForm.reset();
    this.inputGenerationForm.reset({ enrolDependentId: 0 });
  }

  getEnrolDependentName(enrolDependentId) {
    const enrolDependent = this.relationList.find(x => x.enrolDependentId == enrolDependentId);
    return enrolDependent.name + ' & ' + enrolDependent.relationName;
  }

  notifyParentComponent() {
    const depId = this.inputGenerationForm.get('enrolDependentId').value;

    if (depId == null)
      this.inputGenerationForm.patchValue({ enrolDependentId: 0 });

    let data: any = {
      enrolId: this.inputGenerationForm.get('enrolId').value,
      enrolDependentId: this.inputGenerationForm.get('enrolDependentId').value,
      productId: this.inputGenerationForm.get('productId').value,
      productName: this.inputGenerationForm.get('enrolDependentId').value === 0 ?
        this.enrolProducts.find(x => x.id == this.inputGenerationForm.get('productId').value).name :
        this.dependentProducts.find(x => x.productId == this.inputGenerationForm.get('productId').value).product.name,
      natureOfSickness: this.inputGenerationForm.get('natureOfSickness').value,
      claimAmount: 0,
      groupPolicyId: this.inputGenerationForm.get('groupPolicyId').value,
      insuredName: this.inputGenerationForm.get('insuredName').value,
      patientName: this.inputGenerationForm.get('enrolDependentId').value != 0 ?
        this.getEnrolDependentName(this.inputGenerationForm.get('enrolDependentId').value) :
        this.inputGenerationForm.get('insuredName').value,
      payTo: this.inputGenerationForm.get('payTo').value,
      authLetter: this.inputGenerationForm.get('authLetter').value,
      dateOfIncident: this.inputGenerationForm.get('dateOfIncident').value,
      lastWorkedFullTimeDate: this.inputGenerationForm.get('lastWorkedFullTimeDate').value,
      insuranceAmount: this.inputGenerationForm.get('insuranceAmount').value,
      insuredAddress: this.inputGenerationForm.get('insuredAddress').value,
    };

    let pdfFormData = this.getGlClaimFormReport(data);
    data.pdfFormData = pdfFormData;
    // this.resetFromSettings();
    if (this.selectedPatientId != Number(data.enrolDependentId) || this.selectedProductId != Number(data.productId)) {
      this.onProductChange.emit(true);
    } else {
      this.onProductChange.emit(false);
    }
    this.selectedPatientId = data.enrolDependentId;
    this.selectedProductId = data.productId;

    this.onValidInput.emit(data);
  }

  getGlClaimFormReport(entity: any) {
    let formData = this.inputGenerationForm.getRawValue();
    var data = {
      groupPolicyNumber: this.groupPolicies.find(x => x.id = entity.groupPolicyId).groupPolicy.groupNumber,
      certificateNumber: formData.enrol.certificateNumber,
      insuredName: entity.insuredName,
      patientName: entity.patientName,
      productName: entity.productName,
      natureOfSickness: entity.natureOfSickness,
      payTo: this.claimPayToList.find(x => x.id == formData.payTo).value,
      dateOfIncident: entity.dateOfIncident,
      lastWorkedFullTimeDate: entity.lastWorkedFullTimeDate,
      insuranceAmount: entity.insuranceAmount,
      insuredAddress: entity.insuredAddress,
    }

    return data;
  }

}
